import { useState } from "react";
import { AccountDropdownButton } from "./";
import { useAuthInfo } from "../common";
import { Box } from "@mui/material";

export function AccountDropdownMenu({ menuItems }) {
  const decoded = useAuthInfo();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{ color: "white", display: { md: "flex", lg: "none", xl: "none" } }}
    >
      <AccountDropdownButton
        menuItems={menuItems}
        anchorEl={anchorEl}
        open={open}
        handleClick={handleClick}
        handleClose={handleClose}
        decoded={decoded}
      ></AccountDropdownButton>
    </Box>
  );
}
